<template>
	<div class="card__wrapper mb-3">
		<v-card flat class="card-com-lote-alocado py-2 px-0" :class="{'cutting-card': itemLoteAlocado['sgAcaoLoteAlocado'] }">

			<!-- Topo do card -->
			<v-layout class="p-absolute justify-center ma-0 pa-0" style="top: 4px; right: 4px; z-index: 3;">

			<!--  Ações do card -->
<!-- Copiar -->
				<v-tooltip top>
					<template v-slot:activator="{ on, attrs }">
						<v-btn v-bind="attrs" v-on="on" depressed icon x-small
						       @click="mtPreparaCopiarRecortarLoteAlocado({loteAlocado: itemLoteAlocado, tipoAcao: 'CO'})"
						       class="mr-1 card-actions__btn cut"
						>
							<v-icon x-small color="white">fas fa-copy</v-icon>
						</v-btn>
					</template>
					<span>Copiar</span>
				</v-tooltip>

<!-- Recortar -->
				<v-tooltip top>
					<template v-slot:activator="{ on, attrs }">
						<!--            v-if="programacaoAbateSelected.cdStatusProgramacaoAbate != 5"-->
						<v-btn

								v-bind="attrs"
								v-on="on"
								depressed
								icon
								x-small
								@click="mtPreparaCopiarRecortarLoteAlocado({loteAlocado: itemLoteAlocado, tipoAcao: 'RE'})"
								class="mr-1 card-actions__btn cut"
						>
							<v-icon x-small color="white">fas fa-cut</v-icon>
						</v-btn>
					</template>
					<span>Recortar</span>
				</v-tooltip>

<!-- Info -->
<!--				<v-tooltip top>-->
<!--					<template v-slot:activator="{ on, attrs }">-->
<!--						<v-btn-->
<!--								v-bind="attrs"-->
<!--								v-on="on"-->
<!--								depressed-->
<!--								icon-->
<!--								x-small-->
<!--								color="#BDCCCA"-->
<!--								class="mx-1 card-actions__btn info"-->
<!--						>-->
<!--							<v-icon x-small color="white">fas fa-info</v-icon>-->
<!--						</v-btn>-->
<!--					</template>-->
<!--					<span>-->
<!--            <span class="title-tooltip">Lote:</span>-->
<!--            <span class="value-tooltip pl-1">-->
<!--              {{ itemLoteAlocado.loteProducao.nrLoteControle }}-->
<!--            </span>-->
<!--            <br />-->
<!--            <span class="title-tooltip">Extensionista:</span>-->
<!--            <span class="value-tooltip pl-1">-->
<!--              {{-->
<!--		            (itemLoteAlocado.extensionista && itemLoteAlocado.extensionista.nmPessoa) ||-->
<!--		            ""-->
<!--              }}-->
<!--            </span>-->
<!--            <br />-->
<!--            <span class="title-tooltip">Cidade:</span>-->
<!--            <span class="value-tooltip pl-1">-->
<!--              {{ itemLoteAlocado.nmMunicipio }}-->
<!--            </span>-->
<!--          </span>-->
<!--				</v-tooltip>-->

<!-- Deletar	-->
				<v-tooltip top>
					<template v-slot:activator="{ on, attrs }">
						<!--            :disabled="programacaoAbateSelected.cdStatusProgramacaoAbate === 5"-->
						<v-btn
								v-bind="attrs"
								v-on="on"
								depressed
								icon
								x-small
								color="#ff5252"
								@click.native="mtPreparaRemoverLoteAlocado(itemLoteAlocado)"
								:disabled="deleting"
								class="mr-1 card-actions__btn delete"
						>
							<v-icon x-small color="white">fas fa-trash</v-icon>
						</v-btn>
					</template>
					<span>Remover</span>
				</v-tooltip>
			</v-layout>

			<!-- Infos -->
			<v-row class="justify-start ma-0 px-2">
				<v-flex lg11 class="d-flex flex-column ma-0 pa-0 pb-3">
					<span class="label-value">Produtor</span>
					<span class="text-value ma-0 pa-0">
	          {{ itemLoteAlocado.loteDestino.nmProdutor || '--' }}
          </span>
				</v-flex>
			</v-row>
			<v-row class="justify-start ma-0 px-2">
				<v-flex lg11 class="d-flex ma-0 pa-0  pb-3">
					<span class="label-value mr-2">UEP</span>
					<span class="text-value ma-0 pa-0">
	          {{ itemLoteAlocado.loteDestino.nrUnidadeExploracao }}
          </span>
				</v-flex>
			</v-row>

			<v-row class="justify-start flex-column ma-0 px-2  pb-3">
				<span class="label-value pt-0">Período de entrega</span>
				<v-select
						dense
						:menu-props="{
                offsetY: true,
                bottom: true
                }"
						v-model="itemLoteAlocado.cdPeriodoEntregaAlojamento"
						:items="listaPeriodoEntregaAlojamento"
						item-text="nm_periodo_entrega_alojamento"
						item-value="id_periodo_entrega_alojamento"
						no-data-text="Nenhum registro"
						color="primary"
						outlined
						hide-details
						@change="salvarLote()"
						clearable
				/>
			</v-row>

			<!--  Campos da quantia -->
			<v-row class="justify-start d-flex flex-column ma-0 px-2 pb-3">
				<span class="text-value py-0">Quantidade</span>
				<v-row class="ma-0 pa-0">
					<v-col class="pa-0 ma-0" style="min-width: 65px">
						<span class="label-value pt-0">Machos</span>
						<v-text-field
								v-only-number
								outlined
								dense
								:disabled="!canEdit"
								v-model="itemLoteAlocado.qtMachosAlocados"
								hide-details
								v-only-int
								background-color="white"
								@change="salvarLote()"
						/>
					</v-col>
					<v-col class="pa-0 ma-0" style="min-width: 65px">
						<span class="label-value pt-0">Fêmeas</span>
						<v-text-field
								v-only-number
								outlined
								dense
								:disabled="!canEdit"
								v-model="itemLoteAlocado.qtFemeasAlocados"
								hide-details
								v-only-int
								background-color="white"
								@change="salvarLote()"
						/>
					</v-col>
				</v-row>
			</v-row>

			<!--  Gênero sugerido -->
			<v-row class="justify-start ma-0 px-2 pb-3">
				<span class="label-value pt-0 mr-1">Gênero sugerido </span>
				<span class="text-value pt-0">{{ itemLoteAlocado.loteDestino['sgSexoSugerido'] | formataSexoSugerido }}</span>
			</v-row>

			<!-- Alojamentos -->
			<v-row class="justify-start ma-0 px-2">
				<v-col class="pa-0 ma-0 d-flex flex-column" cols="6">
					<span class="label-value pt-0">Alojados</span>
					<span class="text-value pt-0" style="font-size: 16px">
						{{ somaQtTotalAlocados }}
					</span>
				</v-col>
				<v-col class="pa-0 ma-0 d-flex flex-column" cols="6">
					<span class="label-value pt-0 text-no-wrap">Capacidade</span>
					<span class="text-value pt-0 d-flex flex-row" style="font-size: 16px">
						{{ itemLoteAlocado.loteDestino.qtCapacidadeUep }}
					</span>
				</v-col>
			</v-row>

			<!-- Observação -->
      <v-row class="d-flex flex-column pa-2 mt-2 mx-0 card--date">
        <span class="label-value">Observação</span>
        <div class="observacao-lote-destino">
	        {{ itemLoteAlocado.loteDestino.dsObservacao ? itemLoteAlocado.loteDestino.dsObservacao : '--' }}
        </div>
      </v-row>

		<!-- Estado card deletado		-->
			<v-fade-transition hide-on-leave>
				<v-overlay v-if="itemLoteAlocado['blConfirmarDelecao']" absolute>
					<v-row justify="center" align="center" class="ma-2">
						Confirmar exclusão?
					</v-row>
					<v-row justify="center" align="center" class="ma-2">
						<v-tooltip top>
							<template v-slot:activator="{ on }">
								<v-btn v-on="on" fab depressed color="#2BC1B6" small class="white--text"
								       @click="mtUndoDeleteLoteAlocado(itemLoteAlocado)">
									<v-icon small>fas fa-undo</v-icon>
								</v-btn>
							</template>
							<span>Desfazer</span>
						</v-tooltip>
					</v-row>
					<v-row justify="center" align="center" class="ma-2">
						<v-tooltip top>
							<template v-slot:activator="{ on }">
								<v-btn v-on="on" fab depressed color="#ff5252" small class="white--text"
								       @click="deletarLote()">
									<v-icon small>fas fa-trash</v-icon>
								</v-btn>
							</template>
							<span>Deletar</span>
						</v-tooltip>
					</v-row>
				</v-overlay>
			</v-fade-transition>
		</v-card>
		<v-expand-transition>
			<v-progress-linear height="9px" v-show="deleting"
			                   indeterminate class="rounded-b-xl" color="#FF5252">
				<template v-slot:default="{ value }">
					<span class="label-value">Deletando...</span>
				</template>
			</v-progress-linear>
		</v-expand-transition>
	</div>
</template>

<script>
import {mapActions, mapMutations, mapState} from "vuex";
import {validationMixin} from "vuelidate";
import required from "vuelidate/lib/validators/required";

export default {
	name: "LotesAlocadosCard",
	mixins: [validationMixin],
	props: {
		itemCrechario: {
			type: Object,
			default: {},
		},
		itemLoteAlocado: {
			type: Object,
			required: true,
			default: () => {
			},
		},
		nrDia: Number,
		listaPeriodoEntregaAlojamento: {
			type: Array,
			required: true,
		},
	},
	data: () => ({
		canEdit: true,
		deleting: false,
	}),
	validations() {
		return {
			qtAnimais: {
				required,
			},
		};
	},
	filters: {
		formataSexoSugerido(sgSexo) {
			if (sgSexo !== 'MI') return sgSexo === 'FE' ? 'Fêmeas' : 'Machos'
			return 'Misto'
		},
	},
	computed: {
		...mapState("planejamentoAlojamento", ["listaLotesDestino", "listaLotesAlocados"]),
		somaQtTotalAlocados() {
			if (this.listaLotesAlocados.length === 0) return 0

			const lotesAlocadosMesmoLoteDestino = this.listaLotesAlocados.filter(lote =>
					lote.cdPlanejamentoAlojamentoLoteDestino ===
					this.itemLoteAlocado.loteDestino.idPlanejamentoAlojamentoLoteDestino)

			return lotesAlocadosMesmoLoteDestino.length > 0 ?
					lotesAlocadosMesmoLoteDestino.reduce((acc, lote) => acc + parseInt(lote.qtMachosAlocados || 0) +
							parseInt(lote.qtFemeasAlocados || 0), 0) :
					0
		},
		qtAnimaisErrors() {
			const errors = [];
			if (!this.$v.$dirty) return errors;
			!this.$v.qtAnimais.required && errors.push("Campo obrigatório");
			if (!this.$v.qtAnimais.max)
				if (this.qtdDisponiveisWithoutLot <= 0)
					errors.push(`Não há animais disponíveis`);
				else errors.push(`O valor máximo é ${this.qtdDisponiveisWithoutLot}`);
			return errors;
		},
	},
	methods: {
		...mapActions("planejamentoAlojamento", ["ActSaveListaLotesAlocados", "ActRemoveLoteAlocado"]),
		...mapMutations("planejamentoAlojamento", [
				"mtChangeLoteAlocado",
				"mtAtualizarSaldoLotesAlocados",
			  "mtUndoDeleteLoteAlocado",
				"mtPreparaRemoverLoteAlocado",
				"mtPreparaCopiarRecortarLoteAlocado"
		]),
		debouceSaveListaAlocados: _.debounce(function () {
			this.ActSaveListaLotesAlocados(this.$route.params.id)
		}, 2500),
		salvarLote() {
			this.itemLoteAlocado.qtFemeasAlocados = parseInt(this.itemLoteAlocado.qtFemeasAlocados || 0)
			this.itemLoteAlocado.qtMachosAlocados = parseInt(this.itemLoteAlocado.qtMachosAlocados || 0)

			this.mtChangeLoteAlocado(this.itemLoteAlocado)
			this.debouceSaveListaAlocados()
		},
		deletarLote() {
			this.deleting = true
			this.ActRemoveLoteAlocado(this.itemLoteAlocado)
		},
	},
};
</script>

<style scoped lang="scss">
.card__wrapper {
  border-radius: 5px;
}

.cutting-card {
  border: 2px dashed #777777 !important;
}

.gta-btn {
  right: 0;
  margin-right: 5px;
  background-image: repeating-linear-gradient(45deg, violet, indigo, blue, green, yellow, orange, red, violet);
  text-align: center;
  background-size: 800% 800%;
  //-webkit-background-clip: text;
  //-webkit-text-fill-color: transparent;
  font-size: 24px;
  animation: rainbow 8s ease infinite;
  transition: width 5s ease-in-out;

  &:hover {
    opacity: 0;
  }
}

@keyframes rainbow {
  0% {
    background-position: 0% 50%;
    transform: rotate(0deg);
  }
  50% {
    background-position: 100% 25%;
    transform: rotate(180deg);
  }
  100% {
    background-position: 0% 50%;
    transform: rotate(360deg);
  }
}

.label-value {
  font: normal normal normal 12px/16px Roboto;
  letter-spacing: 0px;
  color: #7B9596;
}

.text-value {
  font: normal normal bold 12px/16px Roboto;
  letter-spacing: 0;
  color: #10303DCC;
}

.v-skeleton-loader:first-child :first-child {
  height: 270px;
}

.card--date {
  background: #f7f7f7 0 0 no-repeat padding-box;
  opacity: 1;
	box-shadow: 0 0 0 1px #f7f7f7;
	border-radius: 0 !important;
}

.observacao-lote-destino {
  font: normal normal bold 12px/16px Roboto;
  letter-spacing: 0;
  color: #4b5e62;
	height: 44px;
	overflow-x: hidden;
	overflow-wrap: anywhere;
}

</style>
